import { render, staticRenderFns } from "./Timeoff.vue?vue&type=template&id=3b2a9415&lang=html&"
import script from "./Timeoff.vue?vue&type=script&lang=js&"
export * from "./Timeoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports